<template>
  <Teleport to="body">
    <div v-if="visible" class="fixed top-0 left-0 w-full h-full contenedor-popup-home z-[9999]">
      <div class="popupavisos_prev popupavisos" @click="closePopupOutside">
        <div class="popup-content relative w-[45%] max-[600px]:w-[90%]" ref="popupContent">
          <img :src="imageSrc" alt="Popup Image" @error="imageError" />
          <button @click="closePopup" class="absolute cerrar" style="padding: 0!important">
            <img :src="hoverImage ? '/img/pop-up-home/btn-cerrar-hover.png' : '/img/pop-up-home/btn-cerrar.png'"
              alt="Popup cerrar" class="h-[30px]" @mouseover="hoverImage = true" @mouseleave="hoverImage = false" />
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref } from 'vue'

// Refs reactivas
const visible = ref(false)
const imageSrc = ref(null)
const hoverImage = ref(false)
const popupContent = ref(null)

// Métodos
const closePopup = () => {
  visible.value = false
  document.body.style.overflow = 'visible'
}

const closePopupOutside = (event) => {
  // Verifica si el clic fue fuera del área del popup-content
  if (popupContent.value && !popupContent.value.contains(event.target)) {
    closePopup()
  }
}

const openPopup = (imageSrcParam) => {
  // Si no hay imagen, no hacer nada
  if (!imageSrcParam) {
    return;
  }

  // Configurar el popup
  imageSrc.value = imageSrcParam;
  visible.value = true;

  // Bloquear scroll de la página
  document.body.style.overflow = 'hidden';
};

const imageError = () => {
  visible.value = false
  imageSrc.value = null
  document.body.style.overflow = 'visible'
}

// Exponer métodos para uso externo
defineExpose({
  openPopup,
  closePopup
})
</script>

<style>
.popupavisos {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.33);
  display: flex;
  justify-content: center;
  align-items: center;
}

.popupavisos button.absolute.cerrar {
  right: 15px;
  top: 15px;
}

@media (min-width: 2400px) {
  .popupavisos .popup-content {
    width: 40%;
  }

  .popupavisos button.absolute.cerrar {
    right: 35px;
    top: 25px;
  }
}

@media screen and (min-width: 601px) and (max-width: 1000px) {
  .popupavisos .popup-content {
    width: 70% !important;
  }
}
</style>